




































import { Component, Vue } from 'vue-property-decorator';
import Logo from '@/components/svg/Logo.vue';

@Component({
    components: {
        Logo,
    },
})
export default class Manager extends Vue {
    topNavigationItems = [
        {
            to: '/manage/users',
            label: 'Users',
            icon: 'user',
        },
        {
            to: '/manage/cars',
            label: 'Cars',
            icon: 'car',
        },
        {
            to: '/manage/bids',
            label: 'Bids',
            icon: 'coins',
        },
        {
            to: '/manage/purchases',
            label: 'Purchases',
            icon: 'hammer',
        },
        {
            to: '/manage/settings',
            label: 'Settings',
            icon: 'cog',
        },
    ];

    bottomNavigationItems = [
        {
            to: '/home',
            label: 'Website',
            icon: 'user',
        },
    ];
}
